import React, { createContext, useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

// Create the context
const ShippingContext = createContext();

// Provider component
export const ShippingContextProvider = ({
  children,
  returning,
  key = "selected",
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const [ids, setIds] = useState(new Set());
  const selected = searchParams.get(key);

  const [serialization, setSerialization] = useState(false);

  useEffect(() => {
    if (selected) {
      const newParams = selected?.split("-")?.map(Number)?.filter(Boolean);
      setIds(new Set(newParams));
    }
  }, [selected]);

  const onSelect = (id) => {
    setIds((prev) => {
      const newSet = new Set(prev);
      newSet.has(id) ? newSet.delete(id) : newSet.add(id);
      return newSet;
    });
  };

  const onSelectMultiple = (selectedIds = []) => {
    setIds((prev) => {
      const newSet = new Set(prev);
      selectedIds.forEach((id) => newSet.add(id));
      return newSet;
    });
  };

  const onClear = () => {
    setSearchParams((prev) => {
      if (prev.has(key)) {
        prev.delete(key);
        return prev;
      }
    });
    setIds(new Set());
  };

  const count = ids.size;
  const getIds = () => Array.from(ids);

  return (
    <ShippingContext.Provider
      value={{
        ids,
        getIds,
        onSelect,
        count,
        onClear,
        open,
        setOpen,
        serialization,
        setSerialization,
        onSelectMultiple,
        returning,
      }}
    >
      {children}
    </ShippingContext.Provider>
  );
};

// Hook to use the context
export const useShippingContext = () => {
  const context = useContext(ShippingContext);
  if (!context) {
    throw new Error(
      "useShippingContext must be used within a ShippingContextProvider"
    );
  }
  return context;
};
